import {inject, observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';
import Card, {CardBody, CardFooter, CardHeader} from '../../components/Card';
import ChatFeed from '../../components/ChatUI/ChatFeed';
import Flex from '../../components/Flex';
import {Main, Sider, Wrapper} from '../../components/Layout';
import Persona from '../../components/Persona';
import PersonaStack from '../../components/PersonaStack';
import Text from '../../components/Text';
import ChatList, {KindOfChatType} from '../../containers/ChatList';
import {Auth} from '../../models/authModel';
import {ChatChannelKind} from '../../models/chatChannelModel';
import {ChatModelType} from '../../models/chatModel/chatModel';

type ChannelRouteParams = {
  channelKind: string;
  channelId: string;
};

interface WithInjectedProps extends RouteComponentProps<ChannelRouteParams> {
  chat: ChatModelType;
  auth: Auth;
}

@inject('chat', 'auth')
@observer
export default class CohostClubChannel extends React.Component<
  RouteComponentProps,
  {}
> {
  public componentDidMount() {
    const {loadChannels, setCurrentChannel} = this._withInjectedProps.chat;
    loadChannels(this._channelKind);
    setCurrentChannel(this._channelId);
  }

  public componentWillUnmount() {
    this._withInjectedProps.chat.unsetCurrentChannel();
  }

  public getSnapshotBeforeUpdate(nextProps: WithInjectedProps) {
    const currentChannelId = this._channelId;
    const nextChannelId = Number(nextProps.match.params.channelId);

    if (nextChannelId && currentChannelId !== nextChannelId) {
      this._withInjectedProps.chat.setCurrentChannel(Number(nextChannelId));
    }

    return null;
  }

  public render() {
    const {
      chat: {currentChannel},
      auth
    } = this._withInjectedProps;

    return (
      <Wrapper style={{height: 'calc(100vh - 114px)'}}>
        <Sider
          style={{
            height: '100%',
            width: 360,
            flexBasis: 360,
            overflowX: 'hidden'
          }}
        >
          <Card style={{height: '100%', borderRight: '1px solid #F1F3F6'}}>
            <CardHeader style={{padding: 10}}>
              Cohost Club Conversations
            </CardHeader>
            <CardBody style={{height: 'calc(100% - 59px)', padding: 0}}>
              <ChatList
                loadMore={this._loadMoreChannels}
                kindOfChat={KindOfChatType.COHOST_CLUB_CHAT}
              />
            </CardBody>
          </Card>
        </Sider>
        <Main style={{height: '100%'}}>
          <Card style={{height: '100%', padding: 0}}>
            <CardHeader>
              <Flex style={{height: '100%'}}>
                {currentChannel &&
                currentChannel.thread &&
                currentChannel.thread.listing &&
                currentChannel.thread.listing.previewImageUrl ? (
                  <div style={{marginRight: 12}}>
                    <img
                      src={currentChannel.thread.listing.previewImageUrl}
                      style={{width: 87, display: 'block', borderRadius: 3}}
                    />
                  </div>
                ) : null}
                <Flex direction="column" justify="space-between">
                  <h5>{currentChannel && currentChannel.title}</h5>
                  <div>
                    {currentChannel &&
                    currentChannel.thread &&
                    currentChannel.thread.listing &&
                    currentChannel.thread.listing.internalName ? (
                      <Text
                        color="secondary"
                        fontSize={12}
                        fontWeight={400}
                        style={{marginRight: 8}}
                      >
                        {currentChannel.thread.listing.internalName}
                      </Text>
                    ) : null}
                  </div>
                  <Text color="primary" fontSize={12} fontWeight={400}>
                    <PersonaStack maxLength={3}>
                      {currentChannel &&
                        currentChannel.users.map((u, idx) => (
                          <Persona key={idx}>{u.name}</Persona>
                        ))}
                    </PersonaStack>
                  </Text>
                </Flex>
              </Flex>
            </CardHeader>
            <CardBody
              style={{height: 'calc(100% - 55px - 99.02px)', paddingLeft: 20}}
            >
              {currentChannel && auth.profile ? (
                <ChatFeed
                  messages={this._messages}
                  currentUserId={this._currentUserId}
                  loadMore={this._loadMoreMessages}
                  loadMoreOffsetHeight={10}
                  showSenderName={true}
                />
              ) : null}
            </CardBody>
            <CardFooter style={{padding: 0, backgroundColor: '#F5F6CE'}}>
              <Flex direction="column" justify="center">
                <Text
                  style={{padding: 10, textAlign: 'center', color: '#AA0000'}}
                >
                  Only view in admin view
                </Text>
              </Flex>

              {/* <ChatForm channel={currentChannel} /> */}
            </CardFooter>
          </Card>
        </Main>
      </Wrapper>
    );
  }

  private get _messages() {
    if (!this._withInjectedProps.chat.currentChannel) {
      return [];
    }

    return this._withInjectedProps.chat.currentChannel.sortedMessages.map(
      m => ({
        format: m.format,
        senderId: `${m.senderId}_${m.senderName}`,
        senderName: m.senderName,
        senderAvatar: m.senderAvatar,
        createdAt: m.createdAt
      })
    );
  }

  private get _currentUserId() {
    const {id, firstName, fullName} = this._withInjectedProps.auth.profile!;
    return `${id}_${fullName || firstName}`;
  }

  private get _channelId() {
    return Number(this._withInjectedProps.match.params.channelId);
  }

  private get _channelKind() {
    return this._withInjectedProps.match.params.channelKind as ChatChannelKind;
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private _loadMoreMessages = () =>
    this._withInjectedProps.chat.currentChannel!.loadPreviousCachedMessages();

  private _loadMoreChannels = () => {
    const {
      chat: {loadChannels, nextOffset}
    } = this._withInjectedProps;

    loadChannels(this._channelKind, nextOffset);
  };
}



// WEBPACK FOOTER //
// ./src/pages/CohostClubChannel/CohostClubChannel.tsx